import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const JobsService = {
  getJobDetail(obj) {
    return httpClient.post(endPoints.getJobDetail, obj);
  },
  getAllJobs(obj) {
    return httpClient.post(endPoints.getAllJobs, obj);
  },
  getAllJobsByPagination(obj) {
    return httpClient.post(endPoints.getAllJobsByPagination, obj);
  },
  addJob(obj) {
    return httpClient.post(endPoints.addJob, obj);
  },
  updateJob(obj) {
    return httpClient.post(endPoints.updateJob, obj);
  },
  deleteJob(obj) {
    return httpClient.post(endPoints.deleteJob, obj);
  },
};

export default JobsService;



// WEBPACK FOOTER //
// ./src/service/JobsService.js